import React from "react";

const OtherRequirements = ({ requirements, onChange }) => {
  const MAX = 3;

  const handleChange = (index, value) => {
    const updated = [...requirements];
    updated[index] = value;
    onChange(updated);
  };

  const handleAdd = () => {
    if (requirements.length < MAX) {
      onChange([...requirements, ""]);
    }
  };

  const handleRemove = (index) => {
    const updated = requirements.filter((_, i) => i !== index);
    onChange(updated);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium text-gray-700 capitalize">Any other quality parameters?</p>
        <span className="text-[10px] text-gray-400 font-medium">{requirements.length}/{MAX} added</span>
      </div>

      {requirements.length === 0 && (
        <p className="text-xs text-gray-400 italic">No quality parameters added yet.</p>
      )}

      <div className="space-y-2">
        {requirements.map((req, i) => (
          <div key={i} className="flex items-center gap-2">
            <div className="flex-1 relative">
              <label className="absolute -top-2 left-3 text-[10px] font-medium text-primaryColor bg-white px-1">
                Quality Parameter {i + 1}
              </label>
              <input
                type="text"
                value={req}
                onChange={(e) => handleChange(i, e.target.value)}
                placeholder="Add here..."
                maxLength={200}
                className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:border-primaryColor focus:ring-1 focus:ring-primaryColor/20 transition-all"
              />
            </div>
            <button
              type="button"
              onClick={() => handleRemove(i)}
              className="w-8 h-8 rounded-full bg-red-50 hover:bg-red-100 text-red-500 flex items-center justify-center flex-shrink-0 transition-colors"
              title="Remove"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        ))}
      </div>

      {requirements.length < MAX && (
        <button
          type="button"
          onClick={handleAdd}
          className="
            w-full flex items-center justify-center gap-2
            border-2 border-dashed border-gray-300 hover:border-primaryColor
            text-gray-500 hover:text-primaryColor
            py-2.5 rounded-lg text-sm font-medium
            transition-all duration-150 active:scale-[0.99]
          "
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
          </svg>
          Add Quality Parameter ({requirements.length}/{MAX})
        </button>
      )}
    </div>
  );
};

export default OtherRequirements;